import { useDispatch,useSelector} from "react-redux";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { itemsActions } from "../store/itemsSlice";
import {shopActions} from "../store/shopSlice";
import styles from "../Components/ProductList.module.css";
import React, {Suspense, lazy} from "react";
import Api from "../Components/Api";
const LazyShopItemComponent = lazy(()=> import('../Components/ShopItem'));

const Shop = () => {
  const [shopName, setShopName] = useState()
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const shopId = params.get('shopid');      
  const dispatch = useDispatch();
    useEffect(() => {         
    Api.get(`/hello-world/${shopId}`)
        .then((response) => {
            dispatch(itemsActions.addInitialItems(response.data));
            dispatch(shopActions.addInitialItems(shopId));
        })
      .catch((error) => {
        console.log(`Hello${error}`);
      });
      Api.get(`/bread-crumb/${shopId}`).then((response) => {
        //console.log(response.data)
        setShopName(response.data[0].shop_name)
      })
  }, [shopId,dispatch]);
    const items = useSelector(store => store.items);   
     
    return <><div className={`col-sm-12 ${styles.mainContainer}`}>
        <div className="container-fluid">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><Link to="/">Home</Link></li>
            <li class="breadcrumb-item active" aria-current="page">{shopName}</li>
          </ol>
        </nav>       
        <div className="row">
          <Suspense fallback={<button class="btn btn-primary" type="button" disabled>
            <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
            Loading...
          </button>} >
            {items.map((item) => (
              <LazyShopItemComponent key={item.id} item={item} />
            ))}
          </Suspense>
        </div>
        </div>
      </div>

    </>

}
export default Shop;